import React, { isValidElement, useCallback } from 'react'

const PopoverMenuContentItem = ({ src, label, render, onClick, id, withHr, show = true, disabled, loading, className, type = 'default' }) => {

    const handleClick = useCallback(() => {
        if (onClick) onClick(id);
    }, [onClick, id])

    if (show && render && isValidElement(render)) {
        return render
    }

    return (
        <>
            {show && (
                <div className={`bimmatch-menu-item ${disabled ? "bimmatch-menu-disabled" : "bimmatch-menu-enabled"} menu-type-${type} ${className || ""}`} onClick={handleClick}>
                    {loading ? (
                        <span className="bimmatch-button-loading" />
                    ) : (
                        <>
                            {src && <img src={src} alt="menu-icon" className={`menu-item-icon icon-${id}`} />}
                            {label && <span className="bimmatch-menu-item-label">{label}</span>}
                        </>
                    )}
                </div>
            )}
            {withHr && <hr />}
        </>
    )
}

export default PopoverMenuContentItem